module.exports = __webpack_public_path__ + "media/images/orion_pictos/lifebelt-99dc9569dbf7024b2fcabb8a98980aaf.svg";